document.querySelector("html").classList.remove("no-js");

const body = document.querySelector("body");
const html = document.querySelector("html");

const mq = window.matchMedia("(min-width: 1084px)");

const togglePopoverSupported = typeof body.hidePopover === "function";

if (togglePopoverSupported) {
  isPopoverSupported = true;
} else {
  html.classList.add("no-popover");
  isPopoverSupported = false;
}
// console.log("Popover supported:", isPopoverSupported);

const indexCheck = document
  .querySelector("body")
  .classList.contains("template-index");
const productCheck = document
  .querySelector("body")
  .classList.contains("template-product");
const collectionCheck = document
  .querySelector("body")
  .classList.contains("template-collection");
const searchCheck = document
  .querySelector("body")
  .classList.contains("template-search");
const blogCheck = document
  .querySelector("body")
  .classList.contains("template-blog");

const formCheck = document.getElementById("add-to-cart-form") !== null;
const qtyCheck = document.querySelector(".js-quantity-picker") !== null;
const lineQtyCheck = document.querySelector("quantity-selector") !== null;
const instaCheck = document.querySelector(".section-instagram-feed") !== null;
const gridSectionCheck = document.querySelector(".grid-slider") !== null;
const sizeGuideCheck = document.querySelector(".size-guide__link") !== null;

const upcartCheck = document.querySelector("html").dataset.upcart === "true";

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function toggleExpandedEls() {
  // Select all elements with the 'aria-expanded' attribute
  const expandableElements = document.querySelectorAll("[aria-expanded]");

  // Register beforetoggle event listeners first, before any clicks happen
  expandableElements.forEach((element) => {
    const targetSelector = element.getAttribute("popovertarget");
    
    if (targetSelector) {
      const popoverModal = document.getElementById(targetSelector);

      if (popoverModal) {
        popoverModal.addEventListener("beforetoggle", (event) => {
          if (event.newState === "open") {
            popoverModal.setAttribute("aria-hidden", false);
            element.setAttribute("aria-expanded", true);
            console.log("Popover has been shown");
            onSubmitHidePopover(popoverModal); 
          } else {
            console.log("Popover has been hidden");
            element.setAttribute("aria-expanded", false);
            popoverModal.setAttribute("aria-hidden", true);
          }
        });
      }
    }
  });

  const toggleExpanded = (element) => {
    const isExpanded = element.getAttribute("aria-expanded") === "true";
    // Toggle aria-expanded
    element.setAttribute("aria-expanded", String(!isExpanded));
  };

  // Add click event listener to each element with debounce
  const debouncedToggleExpanded = debounce(toggleExpanded, 300);
  expandableElements.forEach((element) => {
    element.addEventListener("click", () => debouncedToggleExpanded(element));
  });
}

// Widths
const px1024 = window.innerWidth <= 1024;

if (
  navigator.userAgent.indexOf("Safari") != -1 &&
  navigator.userAgent.indexOf("Chrome") == -1
) {
  body.classList.add("browser-safari");
}

// Reccomendations
function reccs() {
  const productRecommendationsSection = document.querySelector(
    "section.recommendations"
  );

  if (!productRecommendationsSection) return;

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(".recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          // Dispatch custom event
          document.dispatchEvent(new CustomEvent("recommendationsLoaded"));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
}

if (productCheck) {
  reccs();
}

function watchChangePopoverAdd(button) {
    button.addEventListener('click', (event) => { 
      let buttonTarget = button.dataset.target,
          form = document.querySelector('#' + buttonTarget);
          // form = formParent.querySelector('form');

        console.log('buttonTarget', buttonTarget);
        console.log('form', form);
      
        form.addEventListener("change", function (event) {
            productForm.onProductOptionChanged(event);
          });
          
    });
}


document.addEventListener('recommendationsLoaded', () => {
  console.log('Recommendations loaded');
 
  document.querySelector('.quick-add-to-cart-button-popover').addEventListener('click', () => {
    console.log('Quick add to cart button clicked');
    cartScripts();
  });
});

// Intersection Observer
function intObs() {
  let observerSelector = ".observed",
    observerObject = document.querySelectorAll(observerSelector),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.1) {
            entry.target.classList.add("in-view");
            entry.target.classList.remove("out-of-view");
          } else {
            entry.target.classList.remove("in-view");
            entry.target.classList.add("out-of-view");
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      }
    );

  observerObject.forEach((holder) => {
    observer.observe(holder);
  });

  window.addEventListener("resize", function () {
    observerObject.forEach((holder) => {
      observer.observe(holder);
    });
  });
}

intObs();

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    intObs();
  });
}

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    intObsMobile();
  });
}

let isMiniCartOpen = false,
    wasTransparent = false;



// On Mini Cart Click
class MiniCart {
  constructor(target) {
      if (isPopoverSupported) {
        document
        .querySelector(".mini-cart")
        .addEventListener("beforetoggle", this.onMiniCartToggle.bind(this));
      } else {
        target.addEventListener("click", this.onMiniCartClick.bind(this));
      }  
    }


  statusClasses() {
    let htmlEl = document.querySelector("html"),
      cartCheck = htmlEl.classList.contains("mini-cart-open"),
      mobileMenuCheck = htmlEl.classList.contains("menu-active"),
      emptyCartCheck = document.querySelector(".mini-cart .cart-contents").classList.contains("cart-contents--empty");

    if (mobileMenuCheck) {
      htmlEl.classList.remove("menu-active");
      htmlEl.classList.add("mini-cart-open");
    } else if (!cartCheck) {
      htmlEl.classList.add("mini-cart-open");
    } else {
      htmlEl.classList.remove("mini-cart-open");
    }
  }

  onMiniCartToggle(event) {
    let htmlEl = document.querySelector("html"),
        header = document.querySelector("header.main-header")

     // Check the state of the header before handling the event
     if (isHeaderTransparent) {
      wasTransparent = true;
    } else {
      wasTransparent = false;
    }

    if (event.newState === "open") {
      this.statusClasses();
      htmlEl.classList.add("mini-cart-open");
      document.querySelector(".mini-cart").classList.add("open");
      isMiniCartOpen = true;
      if (wasTransparent) {
        header.classList.remove("transparent--visible");
      }
      
    } else {
      this.statusClasses();
      htmlEl.classList.remove("mini-cart-open");
      document.querySelector(".mini-cart").classList.remove("open");
      isMiniCartOpen = false;
      if (wasTransparent) {
        header.classList.add("transparent--visible");
      }
    }
  }

  onMiniCartClick(event) {
    let htmlEl = document.querySelector("html"),
        header = document.querySelector("header.main-header")

     // Check the state of the header before handling the event
     if (isHeaderTransparent) {
      wasTransparent = true;
    } else {
      wasTransparent = false;
    }



    if (!htmlEl.classList.contains("mini-cart-open")) {
      this.statusClasses();
      htmlEl.classList.add("mini-cart-open");
      document.querySelector(".mini-cart").classList.add("open");
      isMiniCartOpen = true;
      if (wasTransparent) {
        header.classList.remove("transparent--visible");
      }
    } else {
      this.statusClasses();
      htmlEl.classList.remove("mini-cart-open");
      document.querySelector(".mini-cart").classList.remove("open");
      isMiniCartOpen = false;
      if (wasTransparent) {
        header.classList.add("transparent--visible");
      }
    }
  }

} 

  function onUpcart(event) {
    console.log("upcart is active, mini cart links now use upcartRegisterAddToCart");
    
    document.querySelectorAll(".js-cart").forEach((btn) => {
     btn.addEventListener("click", function (e) {
       if (typeof window.upcartRegisterAddToCart === "function") {
         e.preventDefault();
         window.upcartRegisterAddToCart();
       }
     });
   });

    initUpcartUpsellSlider();
    initUpcartBogoCartUi();
  }

function initUpcartBogoCartUi() {
  if (document.documentElement.hasAttribute("data-upcart-bogo-ui")) return;
  document.documentElement.setAttribute("data-upcart-bogo-ui", "");

  const bogoUiCss =
    /* Hide Complete Your Ritual */
    ".upcart-public-upsell,.upcart-internal-upsell,#up-upsell-carousel,[class*='upcart-public-upsell']{display:none!important;}" +
    /* Hide Enter Code input only — keep line-item BOGO tags visible */
    ".upcart-public-discount-code," +
    ".upcart-internal-discount-code," +
    ".upcart-public-discount-code__form," +
    ".upcart-internal-discount-code__form," +
    ".upcart-public-discount-code__input-wrapper," +
    ".upcart-public-discount-code__input," +
    ".upcart-public-discount-code__button{display:none!important;}" +
    /* Hide summary VIP / discount chips only (footer) */
    ".upcart-public-cart-summary__discount-codes," +
    ".upcart-public-cart-summary__slide-codes," +
    ".upcart-public-cart-summary__discount-label," +
    ".upcart-public-cart-summary__total-discount{display:none!important;}" +
    /* BOGO free line — new UI: dark BOGO badge + Qty. N (no price / old pill) */
    ".upcart-bogo-free-line .upcart-public-component-product-tile__quantity-selector," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__quantity-minus," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__quantity-plus," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__controls .upcart-public-component-product-tile__quantity-selector," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__remove-button," +
    ".upcart-bogo-free-line [class*='quantity-selector']," +
    ".upcart-bogo-free-line [class*='QuantityField']," +
    ".upcart-bogo-free-line [class*='product-tile__remove']," +
    ".upcart-bogo-free-line button[aria-label*='Remove' i]," +
    ".upcart-bogo-free-line button[aria-label*='Delete' i]," +
    ".upcart-bogo-free-line .upcart-public-component-tag__remove-button," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__price," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__prices," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__savings," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__saving," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__discount-codes," +
    ".upcart-bogo-free-line .upcart-public-component-tag," +
    ".upcart-bogo-free-line .upcart-public-component-tag__text," +
    ".upcart-bogo-free-line .upcart-public-component-tag__icon{display:none!important;}" +
    ".almora-upcart-bogo-badge{display:block!important;width:fit-content;background:#094438;color:#fff;font-family:var(--font-body-medium,Arial,sans-serif);font-size:.6875rem;font-weight:600;letter-spacing:.04em;line-height:1.2;padding:.2rem .45rem;border-radius:.2rem;margin:0 0 .35rem;text-transform:uppercase;}" +
    ".almora-upcart-bogo-title-stack{display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:0;min-width:0;}" +
    ".almora-upcart-bogo-qty{display:block!important;color:#6b6b6b;font-family:var(--font-body-family,Arial,sans-serif);font-size:.875rem;font-weight:400;line-height:1.3;margin-top:.35rem;}" +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__product-title," +
    ".upcart-bogo-free-line .upcart-public-component-product-tile__title-link," +
    ".upcart-bogo-free-line a.upcart-product-title-link{display:block!important;width:100%;}" +
    /* Footer padding 0 so You saved strip is full-bleed */
    "[class*='styles_Footer__']{padding:0 0 12px!important;}" +
    "[class*='styles_Footer__']>:not(.almora-upcart-you-saved){margin-left:23px;margin-right:23px;}" +
    "[class*='styles_Footer__'] .almora-upcart-you-saved{width:100%!important;max-width:none;margin:0 0 12px!important;box-sizing:border-box;}" +
    /* You saved strip — mint bar + design SVG badge */
    ".almora-upcart-you-saved{display:flex!important;align-items:center;justify-content:center;gap:.5rem;width:100%;box-sizing:border-box;padding:.75rem 1rem;margin:0;border:0;border-top:1px solid #094438;border-radius:.5rem .5rem 0 0;background:#d7ebe4;color:#094438;font-family:var(--font-body-medium,Arial,sans-serif);font-size:.95rem;font-weight:500;line-height:1.3;text-align:center;}" +
    ".almora-upcart-you-saved[hidden]{display:none!important;}" +
    ".almora-upcart-you-saved__icon{flex-shrink:0;display:block;width:1.25rem;height:1.25rem;line-height:0;}" +
    ".almora-upcart-you-saved__icon svg{display:block;width:100%;height:100%;}" +
    ".almora-upcart-you-saved__text{color:#094438;font-weight:500;}" +
    /* Hide free-shipping rewards block (progress + message) */
    ".upcart-internal-rewards," +
    ".upcart-public-rewards," +
    "[class*='upcart-internal-rewards']," +
    "[class*='upcart-public-rewards']{display:none!important;}";

  const getUpcartRoots = () => {
    const roots = [];
    const push = (root) => {
      if (root && roots.indexOf(root) === -1) roots.push(root);
    };
    if (window.upcartDocumentOrShadowRoot) push(window.upcartDocumentOrShadowRoot);
    ["upCart", "upcart", "up-cart"].forEach((id) => {
      const host = document.getElementById(id);
      if (host?.shadowRoot) push(host.shadowRoot);
      else if (host) push(host);
    });
    document.querySelectorAll("[id*='upcart' i], [id*='UpCart'], [class*='upcart' i]").forEach((el) => {
      if (el.shadowRoot) push(el.shadowRoot);
    });
    // Open shadow hosts that contain cart chrome
    const walk = document.body ? document.body.querySelectorAll("*") : [];
    for (let i = 0; i < walk.length && roots.length < 6; i++) {
      const el = walk[i];
      if (!el.shadowRoot) continue;
      if (
        el.shadowRoot.querySelector(
          ".upcart-public-header, .upcart-public-cart-items, .upcart-public-cart-summary, [class*='upcart-public']"
        )
      ) {
        push(el.shadowRoot);
      }
    }
    if (!roots.length) push(document);
    return roots;
  };

  const injectStyles = (scope) => {
    const target =
      scope === document || scope === document.body ? document.head : scope;
    if (!target) return;
    let style = target.querySelector("#almora-upcart-bogo-ui-css");
    if (!style) {
      style = document.createElement("style");
      style.id = "almora-upcart-bogo-ui-css";
      target.appendChild(style);
    }
    style.textContent = bogoUiCss;
  };

  const hideEl = (el) => {
    if (!el) return;
    el.style.setProperty("display", "none", "important");
    el.setAttribute("aria-hidden", "true");
  };

  const hideModules = (scope) => {
    scope
      .querySelectorAll(
        ".upcart-public-upsell, .upcart-internal-upsell, #up-upsell-carousel, [class*='upcart-public-upsell']"
      )
      .forEach(hideEl);
    // Enter Code module only — do NOT match product-tile__discount-codes (BOGO badge)
    scope
      .querySelectorAll(
        ".upcart-public-discount-code, .upcart-internal-discount-code, .upcart-public-discount-code__form, .upcart-internal-discount-code__form, .upcart-public-discount-code__input-wrapper, .upcart-public-discount-code__input, .upcart-public-discount-code__button"
      )
      .forEach(hideEl);
    scope
      .querySelectorAll(
        ".upcart-public-cart-summary__discount-codes, .upcart-public-cart-summary__slide-codes, .upcart-public-cart-summary__discount-label, .upcart-public-cart-summary__total-discount"
      )
      .forEach(hideEl);
    scope
      .querySelectorAll(
        ".upcart-internal-rewards, .upcart-public-rewards, [class*='upcart-internal-rewards'], [class*='upcart-public-rewards']"
      )
      .forEach(hideEl);
  };

  const formatMoney = (cents, currencyCode) => {
    const amount = (Number(cents) || 0) / 100;
    const currency = currencyCode || window.Shopify?.currency?.active || "INR";
    try {
      let formatted = new Intl.NumberFormat(
        document.documentElement.lang || undefined,
        {
          style: "currency",
          currency: currency,
          maximumFractionDigits: 2,
        }
      ).format(amount);
      if (currency === "INR") formatted = formatted.replace(/₹\s?/, "Rs. ");
      return formatted;
    } catch (e) {
      return "Rs. " + amount.toFixed(2);
    }
  };

  let bogoCartQtyByKey = Object.create(null);
  let bogoFreeTitles = Object.create(null);

  const getTileTitle = (tile) =>
    (
      tile.querySelector(
        ".upcart-public-component-product-tile__product-title, .upcart-public-component-product-tile__title-link, a.upcart-product-title-link, [class*='product-title']"
      )?.textContent || ""
    ).trim();

  const normalizeVariantText = (raw) =>
    String(raw || "")
      .replace(/^(volume|size|variant)\s*:\s*/i, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  const getTileVariantText = (tile) => {
    const el = tile.querySelector(
      ".upcart-public-component-product-tile__variant, [class*='product-tile__variant']"
    );
    return normalizeVariantText(el ? el.textContent : "");
  };

  const getBogoQtyKey = (title, variant) =>
    String(title || "").trim() + "||" + String(variant || "");

  const getTileQtyKey = (tile) =>
    getBogoQtyKey(getTileTitle(tile), getTileVariantText(tile));

  const getCartItemVariantText = (item) => {
    if (item.variant_title && item.variant_title !== "Default Title") {
      return normalizeVariantText(item.variant_title);
    }
    const opts = item.options_with_values || item.options || [];
    if (Array.isArray(opts) && opts.length) {
      return normalizeVariantText(
        opts
          .map((o) => (typeof o === "string" ? o : o.value || o.name || ""))
          .filter(Boolean)
          .join(" / ")
      );
    }
    return "";
  };

  const tileHasBogoProperty = (tile) => {
    const props = tile.querySelectorAll(
      ".upcart-public-component-product-tile__properties, .upcart-public-product-properties__item, [class*='properties']"
    );
    for (const prop of props) {
      if (/_bogo/i.test(prop.textContent || "")) return true;
    }
    return false;
  };

  const tileLooksZeroPriced = (tile) => {
    const priceText = (
      tile.querySelector(
        ".upcart-public-component-product-tile__price, [class*='product-tile__price']"
      )?.textContent || tile.textContent || ""
    ).replace(/\s/g, "");
    const savingsText =
      tile.querySelector(
        ".upcart-public-component-product-tile__savings, [class*='saving']"
      )?.textContent || "";
    return /0\.00|₹0(?:\.00)?|Rs\.?0(?:\.00)?/.test(priceText) && /save/i.test(savingsText || priceText);
  };

  // Badge only for _bogo lines. $0/Save is used only to pick the free tile vs paid twin.
  const isBogoFreeTile = (tile) => {
    if (tileHasBogoProperty(tile)) return true;
    const title = getTileTitle(tile);
    if (!title || !bogoFreeTitles[title]) return false;
    return tileLooksZeroPriced(tile);
  };

  const readTileQty = (tile) => {
    const input = tile.querySelector(
      "input[type='number'], input[name*='quantity' i], [class*='quantity'] input"
    );
    if (input && input.value) {
      const n = parseInt(input.value, 10);
      if (Number.isFinite(n) && n > 0) return n;
    }
    const qtyBox = tile.querySelector(
      "[class*='quantity-selector'], [class*='QuantityField']"
    );
    if (qtyBox) {
      const m = (qtyBox.textContent || "").match(/\d+/);
      if (m) return parseInt(m[0], 10) || 1;
    }
    return 1;
  };

  // Paid-line qty by title+variant — free "Qty. N" follows the matching paid line
  const buildPaidQtyByKey = (scope) => {
    const map = Object.create(null);
    scope
      .querySelectorAll(
        ".upcart-public-component-product-tile, .upcart-public-cart-item"
      )
      .forEach((tile) => {
        if (isBogoFreeTile(tile)) return;
        const key = getTileQtyKey(tile);
        if (!key || key === "||") return;
        map[key] = readTileQty(tile);
      });
    return map;
  };

  const findPaidSiblingQty = (scope, freeTile) => {
    const key = getTileQtyKey(freeTile);
    if (!key || key === "||") return 0;
    const tiles = scope.querySelectorAll(
      ".upcart-public-component-product-tile, .upcart-public-cart-item"
    );
    for (let i = 0; i < tiles.length; i++) {
      const tile = tiles[i];
      if (tile === freeTile || isBogoFreeTile(tile)) continue;
      if (getTileQtyKey(tile) === key) return readTileQty(tile);
    }
    return 0;
  };

  const styleBogoFreeLine = (tile, paidQtyByKey, cartQtyByKey, scope) => {
    tile
      .querySelectorAll(
        ".upcart-public-component-product-tile__quantity-selector, .upcart-public-component-product-tile__quantity-minus, .upcart-public-component-product-tile__quantity-plus, .upcart-public-component-product-tile__remove-button, [class*='quantity-selector'], [class*='QuantityField'], [class*='product-tile__remove'], button[aria-label='Remove'], button[aria-label*='Remove item' i], button[aria-label*='Delete' i], .upcart-public-component-product-tile__price, .upcart-public-component-product-tile__prices, .upcart-public-component-product-tile__savings, .upcart-public-component-product-tile__saving, [class*='product-tile__price'], [class*='product-tile__saving'], .upcart-public-component-product-tile__discount-codes, .upcart-public-component-tag, .upcart-public-component-tag__text, .upcart-public-component-tag__icon"
      )
      .forEach((el) => {
        if (el.closest(".almora-upcart-bogo-badge, .almora-upcart-bogo-qty")) return;
        hideEl(el);
      });

    const titleEl =
      tile.querySelector(
        ".upcart-public-component-product-tile__product-title, .upcart-public-component-product-tile__title-link, a.upcart-product-title-link, [class*='product-title']"
      ) || tile.querySelector("a[href*='/products/']");
    const title = getTileTitle(tile);

    let stack = tile.querySelector(".almora-upcart-bogo-title-stack");
    let badge = tile.querySelector(".almora-upcart-bogo-badge");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "almora-upcart-bogo-badge";
    }
    badge.textContent = "FREE";

    if (!stack && titleEl && titleEl.parentElement) {
      stack = document.createElement("div");
      stack.className = "almora-upcart-bogo-title-stack";
      titleEl.parentElement.insertBefore(stack, titleEl);
      stack.appendChild(badge);
      stack.appendChild(titleEl);
    } else if (stack) {
      if (badge.parentElement !== stack) stack.insertBefore(badge, stack.firstChild);
      if (titleEl && titleEl.parentElement !== stack) {
        if (badge.nextSibling) stack.insertBefore(titleEl, badge.nextSibling);
        else stack.appendChild(titleEl);
      }
    } else if (!badge.parentElement) {
      tile.prepend(badge);
    }

    const variant = tile.querySelector(
      ".upcart-public-component-product-tile__variant, [class*='product-tile__variant']"
    );
    if (stack && variant && variant.parentElement !== stack) {
      stack.appendChild(variant);
    }

    const qtyKey = getTileQtyKey(tile);
    const qty =
      (qtyKey && cartQtyByKey && cartQtyByKey[qtyKey]) ||
      (qtyKey && paidQtyByKey && paidQtyByKey[qtyKey]) ||
      findPaidSiblingQty(scope, tile) ||
      readTileQty(tile) ||
      1;

    let qtyEl = tile.querySelector(".almora-upcart-bogo-qty");
    if (!qtyEl) {
      qtyEl = document.createElement("span");
      qtyEl.className = "almora-upcart-bogo-qty";
    }
    if (stack) {
      stack.appendChild(qtyEl);
    } else {
      const anchor = variant || titleEl || badge;
      if (anchor && anchor.parentElement && qtyEl.parentElement !== anchor.parentElement) {
        if (anchor.nextSibling) {
          anchor.parentElement.insertBefore(qtyEl, anchor.nextSibling);
        } else {
          anchor.parentElement.appendChild(qtyEl);
        }
      } else if (!qtyEl.parentElement) {
        tile.appendChild(qtyEl);
      }
    }
    qtyEl.textContent = "Qty. " + qty;
  };

  let bogoCartQtyTimer = 0;

  const applyBogoFreeUi = (scope) => {
    scope
      .querySelectorAll(
        ".almora-upcart-free-badge, .almora-upcart-free-qty"
      )
      .forEach((el) => el.remove());

    const tiles = scope.querySelectorAll(
      ".upcart-public-component-product-tile, .upcart-public-cart-item"
    );
    tiles.forEach((tile) => {
      const free = isBogoFreeTile(tile);
      tile.classList.toggle("upcart-bogo-free-line", free);
      if (!free) {
        tile.querySelector(".almora-upcart-bogo-badge")?.remove();
        tile.querySelector(".almora-upcart-bogo-qty")?.remove();
        const stack = tile.querySelector(".almora-upcart-bogo-title-stack");
        if (stack) {
          const parent = stack.parentElement;
          while (stack.firstChild) parent?.insertBefore(stack.firstChild, stack);
          stack.remove();
        }
      }
    });

    const paidQtyByKey = buildPaidQtyByKey(scope);
    scope.querySelectorAll(".upcart-bogo-free-line").forEach((tile) => {
      styleBogoFreeLine(tile, paidQtyByKey, bogoCartQtyByKey, scope);
    });
  };

  const syncBogoQtyFromCart = (scope) => {
    fetch(window.Shopify.routes.root + "cart.js?t=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then((r) => r.json())
      .then((cart) => {
        const map = Object.create(null);
        const titles = Object.create(null);
        (cart.items || []).forEach((item) => {
          const props = item.properties || {};
          const isFree =
            props._bogo === "true" || props["_bogo"] === "true";
          if (!isFree) return;
          const title = String(item.product_title || item.title || "").trim();
          if (!title) return;
          const key = getBogoQtyKey(title, getCartItemVariantText(item));
          map[key] = Number(item.quantity) || 1;
          titles[title] = true;
        });
        bogoCartQtyByKey = map;
        bogoFreeTitles = titles;
        applyBogoFreeUi(scope);
      })
      .catch(() => {});
  };

  const markBogoFreeLines = (scope) => {
    applyBogoFreeUi(scope);
    window.clearTimeout(bogoCartQtyTimer);
    bogoCartQtyTimer = window.setTimeout(() => syncBogoQtyFromCart(scope), 80);
  };

  /* Scalloped % badge from design */
  const YOU_SAVED_ICON_VER = "3";
  const youSavedIconSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.76637 0.998806C8.04775 0.68455 8.39224 0.433165 8.77735 0.26106C9.16247 0.0889557 9.57955 0 10.0014 0C10.4232 0 10.8403 0.0889557 11.2254 0.26106C11.6105 0.433165 11.955 0.68455 12.2364 0.998806L12.9364 1.78081C13.0364 1.89271 13.1603 1.98066 13.299 2.03814C13.4377 2.09561 13.5875 2.12113 13.7374 2.11281L14.7874 2.05481C15.2084 2.03168 15.6296 2.09758 16.0235 2.24821C16.4173 2.39883 16.775 2.6308 17.0732 2.92897C17.3714 3.22715 17.6033 3.58483 17.754 3.9787C17.9046 4.37256 17.9705 4.79376 17.9474 5.21481L17.8894 6.26481C17.8812 6.41451 17.9068 6.56414 17.9643 6.70262C18.0217 6.84109 18.1096 6.96488 18.2214 7.06481L19.0044 7.76481C19.3188 8.04619 19.5703 8.39074 19.7425 8.77595C19.9147 9.16116 20.0037 9.57836 20.0037 10.0003C20.0037 10.4223 19.9147 10.8395 19.7425 11.2247C19.5703 11.6099 19.3188 11.9544 19.0044 12.2358L18.2214 12.9358C18.1095 13.0358 18.0215 13.1598 17.964 13.2985C17.9066 13.4371 17.881 13.5869 17.8894 13.7368L17.9474 14.7868C17.9705 15.2079 17.9046 15.6291 17.754 16.0229C17.6033 16.4168 17.3714 16.7745 17.0732 17.0726C16.775 17.3708 16.4173 17.6028 16.0235 17.7534C15.6296 17.904 15.2084 17.9699 14.7874 17.9468L13.7374 17.8888C13.5877 17.8806 13.438 17.9062 13.2996 17.9637C13.1611 18.0212 13.0373 18.109 12.9374 18.2208L12.2374 19.0038C11.956 19.3182 11.6114 19.5698 11.2262 19.742C10.841 19.9142 10.4238 20.0032 10.0019 20.0032C9.57992 20.0032 9.16272 19.9142 8.77751 19.742C8.3923 19.5698 8.04775 19.3182 7.76637 19.0038L7.06636 18.2208C6.96633 18.1089 6.84238 18.0209 6.70372 17.9635C6.56506 17.906 6.41524 17.8805 6.26537 17.8888L5.21537 17.9468C4.79432 17.9699 4.37312 17.904 3.97926 17.7534C3.58539 17.6028 3.22771 17.3708 2.92953 17.0726C2.63136 16.7745 2.39939 16.4168 2.24876 16.0229C2.09814 15.6291 2.03224 15.2079 2.05537 14.7868L2.11337 13.7368C2.12154 13.5871 2.09594 13.4375 2.03847 13.299C1.98101 13.1605 1.89314 13.0367 1.78137 12.9368L0.999365 12.2368C0.684944 11.9554 0.433418 11.6109 0.261213 11.2257C0.0890088 10.8405 0 10.4233 0 10.0013C0 9.57936 0.0890088 9.16216 0.261213 8.77695C0.433418 8.39174 0.684944 8.04719 0.999365 7.76581L1.78137 7.06581C1.89327 6.96577 1.98122 6.84182 2.0387 6.70316C2.09617 6.5645 2.12169 6.41468 2.11337 6.26481L2.05537 5.21481C2.03224 4.79376 2.09814 4.37256 2.24876 3.9787C2.39939 3.58483 2.63136 3.22715 2.92953 2.92897C3.22771 2.6308 3.58539 2.39883 3.97926 2.24821C4.37312 2.09758 4.79432 2.03168 5.21537 2.05481L6.26537 2.11281C6.41507 2.12098 6.5647 2.09538 6.70318 2.03792C6.84165 1.98045 6.96544 1.89258 7.06537 1.78081L7.76637 0.998806ZM13.7084 6.29381C13.8958 6.48133 14.0012 6.73564 14.0012 7.00081C14.0012 7.26597 13.8958 7.52028 13.7084 7.70781L7.70836 13.7078C7.51976 13.89 7.26716 13.9908 7.00496 13.9885C6.74277 13.9862 6.49195 13.881 6.30655 13.6956C6.12114 13.5102 6.01597 13.2594 6.01369 12.9972C6.01141 12.735 6.11221 12.4824 6.29437 12.2938L12.2944 6.29381C12.4819 6.10634 12.7362 6.00102 13.0014 6.00102C13.2665 6.00102 13.5208 6.10634 13.7084 6.29381ZM7.50137 6.00081C7.10354 6.00081 6.72201 6.15884 6.4407 6.44015C6.1594 6.72145 6.00137 7.10298 6.00137 7.50081V7.51081C6.00137 7.90863 6.1594 8.29016 6.4407 8.57147C6.72201 8.85277 7.10354 9.01081 7.50137 9.01081H7.51137C7.90919 9.01081 8.29072 8.85277 8.57203 8.57147C8.85333 8.29016 9.01137 7.90863 9.01137 7.51081V7.50081C9.01137 7.10298 8.85333 6.72145 8.57203 6.44015C8.29072 6.15884 7.90919 6.00081 7.51137 6.00081H7.50137ZM12.5014 11.0008C12.1035 11.0008 11.722 11.1588 11.4407 11.4401C11.1594 11.7215 11.0014 12.103 11.0014 12.5008V12.5108C11.0014 12.9086 11.1594 13.2902 11.4407 13.5715C11.722 13.8528 12.1035 14.0108 12.5014 14.0108H12.5114C12.9092 14.0108 13.2907 13.8528 13.572 13.5715C13.8533 13.2902 14.0114 12.9086 14.0114 12.5108V12.5008C14.0114 12.103 13.8533 11.7215 13.572 11.4401C13.2907 11.1588 12.9092 11.0008 12.5114 11.0008H12.5014Z" fill="#094438"/>' +
    "</svg>";
  const ensureYouSavedBanner = (scope) => {
    const footer =
      scope.querySelector("[class*='styles_Footer__']") ||
      scope.querySelector("[class*='Footer__']");
    const summary =
      footer ||
      scope.querySelector(".upcart-public-cart-summary") ||
      scope.querySelector("[class*='cart-summary']") ||
      scope.querySelector(".upcart-public-cart-items")?.parentElement;
    if (!summary) return null;

    let banner = scope.querySelector(".almora-upcart-you-saved");
    if (!banner) {
      banner = document.createElement("div");
      banner.className = "almora-upcart-you-saved";
      banner.hidden = true;
    }

    // Prefer Footer as parent so strip is full-bleed (no 23px inset)
    const checkout =
      summary.querySelector("a.upcart-checkout-button") ||
      summary.querySelector(".upcart-checkout-button") ||
      summary.querySelector('[class*="checkout-button"]') ||
      summary.querySelector("a[href*='checkout']");
    const mountParent = footer || checkout?.parentElement || summary;
    const beforeNode = footer
      ? footer.firstChild
      : checkout || summary.firstChild;
    if (banner.parentElement !== mountParent) {
      mountParent.insertBefore(banner, beforeNode);
    } else if (beforeNode && banner !== beforeNode && banner.nextSibling !== beforeNode) {
      // Keep strip above checkout / at top of footer
      if (footer && banner !== footer.firstChild) {
        footer.insertBefore(banner, footer.firstChild);
      } else if (!footer && checkout && banner.nextSibling !== checkout) {
        mountParent.insertBefore(banner, checkout);
      }
    }

    if (banner.getAttribute("data-icon-ver") !== YOU_SAVED_ICON_VER) {
      const prev = banner.querySelector(".almora-upcart-you-saved__text");
      const savedText = prev ? prev.textContent : "";
      banner.setAttribute("data-icon-ver", YOU_SAVED_ICON_VER);
      banner.innerHTML =
        '<span class="almora-upcart-you-saved__icon" aria-hidden="true">' +
        youSavedIconSvg +
        "</span>" +
        '<span class="almora-upcart-you-saved__text"></span>';
      const next = banner.querySelector(".almora-upcart-you-saved__text");
      if (next && savedText) next.textContent = savedText;
    }
    return banner;
  };

  const parseMoneyToCents = (text) => {
    const m = String(text || "")
      .replace(/\u00a0/g, " ")
      .match(/([\d,]+(?:\.\d+)?)/);
    if (!m) return 0;
    return Math.round(parseFloat(m[1].replace(/,/g, "")) * 100);
  };

  // Instant: sum visible "Save Rs. …" on line items (matches drawer)
  const calcSavedFromDrawer = (scope) => {
    let cents = 0;
    const tiles = scope.querySelectorAll(
      ".upcart-public-component-product-tile, [class*='product-tile']"
    );
    tiles.forEach((tile) => {
      const nodes = tile.querySelectorAll("span, div, p");
      for (let i = 0; i < nodes.length; i++) {
        const el = nodes[i];
        if (el.children && el.children.length) continue;
        const t = (el.textContent || "").trim();
        if (!/^Save\b/i.test(t)) continue;
        cents += parseMoneyToCents(t);
        break;
      }
    });
    if (cents > 0) return cents;
    // Fallback selectors
    scope
      .querySelectorAll(
        ".upcart-public-component-product-tile__savings, [class*='product-tile__savings']"
      )
      .forEach((el) => {
        cents += parseMoneyToCents(el.textContent || "");
      });
    return cents;
  };

  const calcSavedCents = (cart) => {
    let fromLines = 0;
    for (const item of cart.items || []) {
      const lineDisc =
        Number(item.line_level_total_discount) ||
        Number(item.total_discount) ||
        0;
      if (lineDisc > 0) {
        fromLines += lineDisc;
        continue;
      }
      const orig = Number(item.original_line_price) || 0;
      const finalRaw = Number(item.final_line_price);
      const final = Number.isFinite(finalRaw)
        ? finalRaw
        : Number(item.line_price) || 0;
      if (orig > final) fromLines += orig - final;
    }
    if (fromLines > 0) return fromLines;
    return Number(cart.total_discount) || 0;
  };

  const applySavedToBanner = (banner, saved, currency) => {
    if (!banner) return;
    const textEl = banner.querySelector(".almora-upcart-you-saved__text");
    if (!textEl) return;
    if (saved > 0) {
      textEl.textContent =
        "You saved " + formatMoney(saved, currency) + " on this order";
      banner.hidden = false;
    } else {
      textEl.textContent = "";
      banner.hidden = true;
    }
  };

  let quietMutations = false;
  const paintYouSaved = (scope, saved, currency) => {
    quietMutations = true;
    try {
      const banner = ensureYouSavedBanner(scope);
      applySavedToBanner(
        banner,
        saved,
        currency || window.Shopify?.currency?.active
      );
    } finally {
      requestAnimationFrame(() => {
        quietMutations = false;
      });
    }
  };

  // Fast path — only paint when drawer exposes Save amounts
  const syncYouSavedFromDom = (scope) => {
    const cents = calcSavedFromDrawer(scope);
    if (cents > 0) paintYouSaved(scope, cents);
  };

  let cartSyncTimer = 0;
  let cartSyncGen = 0;
  const syncYouSavedFromCart = (scope) => {
    const gen = ++cartSyncGen;
    fetch(window.Shopify.routes.root + "cart.js?t=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then((r) => r.json())
      .then((cart) => {
        if (gen !== cartSyncGen) return;
        const fromDom = calcSavedFromDrawer(scope);
        const fromCart = calcSavedCents(cart);
        // Prefer drawer sum when present (what the customer sees on lines)
        paintYouSaved(
          scope,
          fromDom > 0 ? fromDom : fromCart,
          cart.currency
        );
      })
      .catch(() => {
        if (gen !== cartSyncGen) return;
        syncYouSavedFromDom(scope);
      });
  };

  const refreshYouSaved = (scope) => {
    syncYouSavedFromDom(scope);
    window.clearTimeout(cartSyncTimer);
    cartSyncTimer = window.setTimeout(() => syncYouSavedFromCart(scope), 80);
  };

  let scheduled = false;
  const refreshAll = (withMoney) => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const roots = getUpcartRoots();
      roots.forEach((scope) => {
        injectStyles(scope);
        hideModules(scope);
        markBogoFreeLines(scope);
        if (withMoney !== false) refreshYouSaved(scope);
        else ensureYouSavedBanner(scope);
      });
    });
  };

  const watchScope = (scope) => {
    const node = scope === document ? document.body : scope;
    if (!node || node.__bogoUiWatch) return;
    node.__bogoUiWatch = true;
    let mutTimer = 0;
    new MutationObserver(() => {
      if (quietMutations) return;
      window.clearTimeout(mutTimer);
      mutTimer = window.setTimeout(() => {
        injectStyles(scope);
        hideModules(scope);
        markBogoFreeLines(scope);
        refreshYouSaved(scope);
      }, 60);
    }).observe(node, { childList: true, subtree: true });
  };

  const start = () => {
    getUpcartRoots().forEach((scope) => {
      injectStyles(scope);
      hideModules(scope);
      watchScope(scope);
      refreshYouSaved(scope);
    });
  };

  window.almoraRefreshYouSaved = () => {
    getUpcartRoots().forEach((scope) => refreshYouSaved(scope));
  };

  if (typeof window.upcartSubscribeCartOpened === "function") {
    window.upcartSubscribeCartOpened(start);
  }
  if (typeof window.upcartSubscribeCartLoaded === "function") {
    window.upcartSubscribeCartLoaded(start);
  }
  if (typeof window.upcartSubscribeAddedToCart === "function") {
    window.upcartSubscribeAddedToCart(() => {
      getUpcartRoots().forEach((scope) => {
        hideModules(scope);
        refreshYouSaved(scope);
      });
    });
  }

  document.addEventListener("almora:cart-updated", () => {
    getUpcartRoots().forEach((scope) => {
      hideModules(scope);
      refreshYouSaved(scope);
    });
  });

  document.addEventListener(
    "click",
    (e) => {
      const path = typeof e.composedPath === "function" ? e.composedPath() : [];
      let inUpcart = false;
      let qtyAction = false;
      for (let i = 0; i < path.length; i++) {
        const n = path[i];
        if (!n || !n.tagName) continue;
        const cls = typeof n.className === "string" ? n.className : "";
        const id = n.id || "";
        if (/upcart/i.test(cls) || /upcart/i.test(id)) inUpcart = true;
        if (
          /quantity|Quantity/i.test(cls) ||
          /Increase|Decrease|Remove|Delete|Plus|Minus/i.test(
            (n.getAttribute && n.getAttribute("aria-label")) || ""
          )
        ) {
          qtyAction = true;
        }
      }
      if (!inUpcart || !qtyAction) return;
      const refreshFs = () => {
        getUpcartRoots().forEach((scope) => {
          hideModules(scope);
          refreshYouSaved(scope);
        });
      };
      window.setTimeout(refreshFs, 50);
      window.setTimeout(refreshFs, 400);
    },
    true
  );

  start();
  window.addEventListener("load", start, { once: true });
  window.setTimeout(start, 800);
  window.setTimeout(start, 2000);
}

function initUpcartUpsellSlider() {
  if (document.documentElement.hasAttribute("data-upcart-upsell-watch")) return;
  document.documentElement.setAttribute("data-upcart-upsell-watch", "");

  const sliderCss =
    '.upcart-public-upsell{position:relative;}' +
    '.upcart-public-upsell__title{display:flex;align-items:center;justify-content:space-between;gap:.5rem;padding-right:4.5rem;}' +
    '.upcart-upsell-nav{position:absolute;top:1.15rem;right:.75rem;display:flex;align-items:center;gap:.125rem;z-index:2;}' +
    '.upcart-upsell-nav__btn{display:flex;align-items:center;justify-content:center;width:2rem;height:2rem;padding:0;border:0;background:transparent;color:var(--color-main,#094438);cursor:pointer;}' +
    '.upcart-upsell-nav__btn svg{width:1.25rem;height:1.25rem;pointer-events:none;}' +
    '.upcart-upsell-nav__btn[data-upsell-prev] svg{transform:rotate(90deg);}' +
    '.upcart-upsell-nav__btn[data-upsell-next] svg{transform:rotate(-90deg);}' +
    '.upcart-upsell-nav__btn:disabled{opacity:.35;cursor:default;}' +
    '.upcart-public-upsell__vertical-layout-wrapper,.upcart-upsell-scroller{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;gap:.75rem;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;padding-right:1rem;}' +
    '.upcart-public-upsell__vertical-layout-wrapper::-webkit-scrollbar,.upcart-upsell-scroller::-webkit-scrollbar{display:none;}' +
    '.upcart-public-upsell__vertical-layout-wrapper>.upcart-public-component-upsell-tile,.upcart-upsell-scroller>.upcart-public-component-upsell-tile{flex:0 0 calc(100% - 1.75rem)!important;width:calc(100% - 1.75rem)!important;max-width:calc(100% - 1.75rem);min-width:0;scroll-snap-align:start;}';

  const caret =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M11.9264 14.8816L6.61865 9.57391L7.32635 8.86621L11.9264 13.4662L16.5264 8.86621L17.2341 9.57391L11.9264 14.8816Z" fill="currentColor"/></svg>';

  const getUpcartRoot = () => {
    if (window.upcartDocumentOrShadowRoot) return window.upcartDocumentOrShadowRoot;
    const host = document.getElementById("upCart") || document.getElementById("upcart");
    if (host && host.shadowRoot) return host.shadowRoot;
    return document;
  };

  const injectStyles = (scope) => {
    const target = scope === document || scope === document.body ? document.head : scope;
    if (!target || target.querySelector("#upcart-upsell-slider-css")) return;
    const style = document.createElement("style");
    style.id = "upcart-upsell-slider-css";
    style.textContent = sliderCss;
    target.appendChild(style);
  };

  const setupSlider = (root) => {
    if (root.querySelector(".upcart-upsell-nav")) return;
    if (root.querySelector(".upcart-public-component-carousel__button")) return;

    const tiles = Array.from(root.querySelectorAll(".upcart-public-component-upsell-tile"));
    if (tiles.length < 2) return;

    let scroller = root.querySelector(".upcart-public-upsell__vertical-layout-wrapper");
    if (!scroller) scroller = tiles[0].parentElement;
    if (!scroller) return;

    scroller.classList.add("upcart-upsell-scroller");
    scroller.style.setProperty("display", "flex", "important");
    scroller.style.setProperty("flex-direction", "row", "important");
    scroller.style.setProperty("flex-wrap", "nowrap", "important");
    scroller.style.setProperty("overflow-x", "auto", "important");

    const nav = document.createElement("div");
    nav.className = "upcart-upsell-nav";
    nav.innerHTML =
      '<button type="button" class="upcart-upsell-nav__btn" data-upsell-prev aria-label="Previous product">' +
      caret +
      "</button>" +
      '<button type="button" class="upcart-upsell-nav__btn" data-upsell-next aria-label="Next product">' +
      caret +
      "</button>";
    root.appendChild(nav);

    const prev = nav.querySelector("[data-upsell-prev]");
    const next = nav.querySelector("[data-upsell-next]");

    const slideBy = (direction) => {
      const amount = tiles[0].getBoundingClientRect().width + 12;
      scroller.scrollBy({ left: direction * amount, behavior: "smooth" });
    };

    const updateNav = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      prev.disabled = scroller.scrollLeft <= 1;
      next.disabled = scroller.scrollLeft >= maxScroll - 1;
    };

    prev.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      slideBy(-1);
    });
    next.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      slideBy(1);
    });
    scroller.addEventListener("scroll", updateNav, { passive: true });
    updateNav();
  };

  let scheduled = false;
  const scan = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const scope = getUpcartRoot();
      injectStyles(scope);
      scope.querySelectorAll(".upcart-public-upsell").forEach(setupSlider);
    });
  };

  const watchScope = (scope) => {
    const node = scope === document ? document.body : scope;
    if (!node || node.__upsellWatch) return;
    node.__upsellWatch = true;
    new MutationObserver(scan).observe(node, { childList: true, subtree: true });
  };

  const start = () => {
    const scope = getUpcartRoot();
    injectStyles(scope);
    watchScope(scope);
    scan();
  };

  if (typeof window.upcartSubscribeCartOpened === "function") {
    window.upcartSubscribeCartOpened(start);
  }
  if (typeof window.upcartSubscribeCartLoaded === "function") {
    window.upcartSubscribeCartLoaded(start);
  }

  start();
  window.addEventListener("load", start, { once: true });

  if (typeof window.upcartSubscribeCartOpened !== "function") {
    let tries = 0;
    const wait = setInterval(() => {
      tries += 1;
      if (typeof window.upcartSubscribeCartOpened === "function") {
        clearInterval(wait);
        window.upcartSubscribeCartOpened(start);
        if (typeof window.upcartSubscribeCartLoaded === "function") {
          window.upcartSubscribeCartLoaded(start);
        }
        start();
      } else if (document.getElementById("upCart")) {
        clearInterval(wait);
        start();
      } else if (tries > 40) {
        clearInterval(wait);
      }
    }, 250);
  }
}

// Video Icon

// icon-play
// On click video element, play video, hide icon and reveal video controls.

function videoIcon(video) {
  let videoWrapper = video.parentNode,
      icon = videoWrapper.querySelector(".icon-play");

  videoWrapper.onclick = null;
  video.onclick = null;

  videoWrapper.addEventListener("click", function (event) {
    event.preventDefault();
    if (video.paused) {
      video.play().then(() => {
        videoWrapper.classList.add("is-playing");
        icon.setAttribute("aria-hidden", true);
        video.setAttribute("controls", "controls");
        console.log("video is playing");
      }).catch((err) => {
        console.warn("Video play() failed:", err);
      });
    } else { 
      video.pause();
      videoWrapper.classList.remove("is-playing");
      icon.setAttribute("aria-hidden", false);
      video.removeAttribute("controls");
      console.log("video is paused");
    }
  });

  video.addEventListener('ended', function() {
    video.pause();
    video.currentTime = 0;
    videoWrapper.classList.remove("is-playing");
    icon.setAttribute("aria-hidden", false);
    icon.setAttribute("aria-label", "Play video");
    video.removeAttribute("controls");
    console.log("video has ended");
  });
}





function megaMenuMouseOver() {
  let megaMenu = document.querySelector(".mega-menu") !== null,
    search = document.querySelector(".header-search");

  // console.log("megaMenuMouseOver");
  // console.log("megaMenu exists");
  let megaMenuLinks = document.querySelectorAll(".megamenu-trigger");

  megaMenuLinks.forEach((link) => {
    link.addEventListener("mouseover", function (event) {
      console.log("mouseover");

      let target = link.getAttribute("data-target"),
        targetEl = document.getElementById(target);

      // if (targetEl) {
      //   targetEl.showPopover();
      //   targetEl.setAttribute("aria-hidden", false);
      //   link.setAttribute("aria-expanded", true);
      // }

      targetEl.addEventListener("mouseleave", function (event) {
        targetEl.hidePopover();
        targetEl.setAttribute("aria-hidden", true);
        link.setAttribute("aria-expanded", false);
      });
    });
  });

  // if (search !== null) {
  //   search.addEventListener("mouseover", function (event) {
  //     let searchInput = search.querySelector(".js-search-input");

  //     if (searchInput) {
  //       searchInput.focus();
  //     }
  //   });

  //   search.addEventListener("mouseleave", function (event) {
  //     let searchInput = search.querySelector(".js-search-input");

  //     search.hidePopover();

  //     if (searchInput) {
  //       searchInput.blur();
  //     }

  //     if (html.classList.contains("search-active")) {
  //       html.classList.remove("search-active");
  //     }
  //   });
  // }
}

megaMenuMouseOver();

class MobileMenu {
  constructor(target) {
    this.target = target;
    this.eventListenerAdded = false;
    this.addEventListener();
  }

  addEventListener() {
    if (!this.eventListenerAdded) {
      if (isPopoverSupported) {
        document
        .getElementById("mobile-menu")
        .addEventListener(
          "toggle",
          debounce(this.onMenuToggle.bind(this), 50)
        );
      } else {
        this.target.addEventListener("click", debounce(this.onMenuClick.bind(this), 50));
      }
     
      this.eventListenerAdded = true;
      // console.log("Event listener added to mobile-menu");
    } else {
      // console.log("Event listener already added to mobile-menu");
    }
  }

  statusClasses() {
    let htmlEl = document.querySelector("html"),
      cartCheck = htmlEl.classList.contains("mini-cart-open"),
      mobileMenuCheck = htmlEl.classList.contains("menu-active");

    if (cartCheck) {
      htmlEl.classList.add("menu-active");
      htmlEl.classList.remove("mini-cart-open");
    } else if (!mobileMenuCheck) {
      htmlEl.classList.add("menu-active");
    } else {
      htmlEl.classList.remove("menu-active");
    }
  }

  onMenuToggle(event) {
    if (event.newState === "open") {
      this.statusClasses();
      console.log("Menu has been shown");
    } else {
      this.statusClasses();
      console.log("menu has been hidden");
    }
  }

  onMenuClick(event) {
    if (!html.classList.contains("menu-active")) {
      this.statusClasses();
      console.log("Menu has been shown");
    } else {
      this.statusClasses();
      console.log("menu has been hidden");
    }
  }
}

function quickAddCloseListener () {
  let closers = document.querySelectorAll(".card-product--mini__close");

  closers.forEach((close) => {
    close.addEventListener("click", function (event) {
      event.preventDefault();

      let openPopover = document.querySelector(".quick-add--popover:popover-open"),
          parentPopover = close.closest(".quick-add--popover");

      if (parentPopover) {
        parentPopover.hidePopover();
        parentPopover.setAttribute("aria-hidden", true);
      }
    });
  });
}

// function quickAddPopoverFallback() {
//   let quickAddButtons = document.querySelectorAll(".quick-add-to-cart-button-popover"),
//       html = document.querySelector("html");

//   quickAddButtons.forEach((button) => {

//     button.addEventListener("click", function (event) {
//       event.preventDefault();

//       // Close any open popovers
//       let openPopover = document.querySelector(".quick-add--popover.is-open");
      
//       if (openPopover) {
//         openPopover.classList.remove("is-open");
//         openPopover.remove();
//       }

//       // Open the clicked popover
//       let popover = button.nextElementSibling;
//       if (popover && popover.tagName === "FORM" && popover.classList.contains("quick-add--popover")) {
//         popover.classList.add("is-open");
//         html.classList.add("quick-add-popover-open");

//         // Move the popover to the body
//         document.body.appendChild(popover);

//         // Add event listener to close popover when clicking outside
//         document.addEventListener("click", function handleClickOutside(event) {
//           if (!popover.contains(event.target) && !button.contains(event.target)) {
//             popover.classList.remove("is-open");
//             popover.remove();
//             html.classList.remove("quick-add-popover-open");
//             document.removeEventListener("click", handleClickOutside);
//           }
//         });
//       }
//     });
//   });
// }


function readMoreButton(button) {
  let buttonParent = button.parentNode;
  console.log(buttonParent);

  button.addEventListener("click", function (event) {
    event.preventDefault();
    console.log("click");

    buttonParent.classList.toggle("is-open");
    
    buttonParent
      .querySelector(".read-more-description .description-full")
      .classList.toggle("visually-hidden");
    button.textContent = buttonParent.classList.contains("is-open")
      ? "Read less"
      : "Read more";
  });
}

var extendedDescription =
  document.querySelector(".description-short_description") !== null;

function fixedAddToCart() {
  const form = document.querySelector(".js-fix-on-scroll");
  if (!form) return;

  const atcButton = form.querySelector(
    ".add-to-cart-form__buttons .add-to-cart-button"
  );
  if (!atcButton) return;

  const parent = form.parentNode;
  if (!parent) return;

  const positionSentinel = (sentinelEl) => {
    if (form.classList.contains("fixed-add-to-cart")) return;

    const parentRect = parent.getBoundingClientRect();
    const buttonRect = atcButton.getBoundingClientRect();

    sentinelEl.style.top = `${buttonRect.top - parentRect.top}px`;
    sentinelEl.style.left = `${buttonRect.left - parentRect.left}px`;
    sentinelEl.style.width = `${buttonRect.width}px`;
    sentinelEl.style.height = `${Math.max(buttonRect.height, 1)}px`;
  };

  const setStickyAtc = (spacerEl, shouldStick) => {
    const isSticky = form.classList.contains("fixed-add-to-cart");
    if (shouldStick === isSticky) return;

    if (shouldStick) {
      const formHeight = form.offsetHeight;
      spacerEl.style.height = `${formHeight}px`;
      if (!spacerEl.parentNode) parent.insertBefore(spacerEl, form);
      document.body.appendChild(form);
      form.classList.add("js-fixed");
      form.classList.add("fixed-add-to-cart");
    } else {
      parent.insertBefore(form, spacerEl);
      spacerEl.remove();
      form.classList.remove("js-fixed");
      form.classList.remove("fixed-add-to-cart");
    }
  };

  if (form.hasAttribute("data-atc-sticky-init")) {
    const existing = parent.querySelector(":scope > .js-atc-sentinel");
    if (existing) positionSentinel(existing);
    return;
  }

  form.setAttribute("data-atc-sticky-init", "");

  const sentinel = document.createElement("div");
  sentinel.className = "js-atc-sentinel";
  sentinel.setAttribute("aria-hidden", "true");
  parent.insertBefore(sentinel, form);

  const spacer = document.createElement("div");
  spacer.className = "js-atc-spacer";
  spacer.setAttribute("aria-hidden", "true");

  positionSentinel(sentinel);

  const observer = new IntersectionObserver(
    (entries) => {
      setStickyAtc(spacer, !entries[0].isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);

  if (typeof ResizeObserver === "function") {
    const resizeObserver = new ResizeObserver(() => {
      positionSentinel(sentinel);
    });
    resizeObserver.observe(form);
  }
}

function onFilterClick(filter) {
  filter.addEventListener("click", function (event) {
    if (html.classList.contains("filter-active")) {
      html.classList.remove("filter-active");
    } else {
      html.classList.add("filter-active");
    }
  });
}

function setSearchActiveState(isActive) {
  html.classList.toggle("search-active", isActive);
}

function focusSearchInputField() {
  const searchInput = document.querySelector(".js-search-input");

  if (searchInput) {
    searchInput.focus();
  }
}

function initSearchPopoverState() {
  const searchPopover = document.getElementById("inline-search");

  if (!searchPopover || searchPopover.dataset.searchPopoverInitialized === "true") {
    return;
  }

  searchPopover.dataset.searchPopoverInitialized = "true";

  if (!togglePopoverSupported) {
    setSearchActiveState(false);
    return;
  }

  searchPopover.addEventListener("beforetoggle", (event) => {
    const isOpen = event.newState === "open";
    setSearchActiveState(isOpen);

    if (isOpen) {
      setTimeout(() => {
        focusSearchInputField();
      }, 0);
    }
  });

  setSearchActiveState(searchPopover.matches(":popover-open"));
}

function onSearchClick(search) {
  if (search.dataset.searchClickInitialized === "true") {
    return;
  }

  search.dataset.searchClickInitialized = "true";

  search.addEventListener("click", function (event) {
    if (togglePopoverSupported) {
      return;
    }

    const nextState = !html.classList.contains("search-active");
    setSearchActiveState(nextState);

    if (nextState) {
      focusSearchInputField();
    }
  });
}

let searchLinks = document.querySelectorAll(".js-search");

// Search Form
class SearchForm {
  constructor(target) {
    this.input = target;
    this.form = this.input.closest("form");
    if (!this.form) {
      console.log("[SearchForm] no parent form found for input");
      return;
    }

    this.button = this.form.querySelector(".js-search-submit");
    this.suggestions = this.form.querySelector(".js-search-suggestions");
    this.predictiveSearchUrl =
      this.form.dataset.predictiveSearchUrl || "/search/suggest";
    this.abortController = null;
    this.getSuggestionsDebounced = debounce(
      this.getSuggestions.bind(this),
      220
    );

    if (!this.suggestions) {
      const suggestionsContainer = document.createElement("div");
      suggestionsContainer.className =
        "form-search__suggestions js-search-suggestions visually-hidden";
      suggestionsContainer.setAttribute("aria-live", "polite");
      const termsWrapper = this.form.querySelector(".form-search__terms");
      (termsWrapper || this.form).appendChild(suggestionsContainer);
      this.suggestions = suggestionsContainer;
      console.log("[SearchForm] suggestions container created dynamically");
    }

    console.log("[SearchForm] initialized", {
      predictiveSearchUrl: this.predictiveSearchUrl,
      hasButton: Boolean(this.button),
      hasSuggestions: Boolean(this.suggestions),
    });

    this.input.addEventListener("input", this.onSearchInput.bind(this));
    this.input.addEventListener("focus", this.onSearchFocus.bind(this));
    this.input.addEventListener("keydown", this.onSearchKeyDown.bind(this));
    document.addEventListener("click", this.onDocumentClick.bind(this));
  }

  onSearchInput(event) {
    const query = event.target.value.trim();
    const shouldDisableButton = query.length === 0;
    console.log("[SearchForm] input event triggered:", query);

    if (this.button && shouldDisableButton) {
      this.button.setAttribute("disabled", true);
      this.button.classList.add("btn-disabled");
      this.button.classList.add("opacity-025");
    } else if (this.button) {
      this.button.classList.remove("btn-disabled");
      this.button.classList.remove("opacity-025");
      this.button.removeAttribute("disabled");
    }

    if (!this.predictiveSearchUrl) {
      return;
    }

    if (query.length < 2) {
      this.clearSuggestions();
      return;
    }

    this.getSuggestionsDebounced(query);
  }

  onSearchFocus(event) {
    const query = event.target.value.trim();
    if (!this.predictiveSearchUrl || query.length < 2) {
      return;
    }

    if (this.suggestions.innerHTML.trim().length) {
      this.suggestions.classList.remove("visually-hidden");
    } else {
      this.getSuggestionsDebounced(query);
    }
  }

  onSearchKeyDown(event) {
    if (event.key === "Escape") {
      this.clearSuggestions();
    }
  }

  onDocumentClick(event) {
    if (!this.form.contains(event.target)) {
      this.clearSuggestions();
    }
  }

  async getSuggestions(query) {
    if (!this.predictiveSearchUrl) {
      console.log("[SearchForm] predictive URL missing, skipping");
      return;
    }

    const predictiveSearchJsonUrl = this.predictiveSearchUrl.includes(".json")
      ? this.predictiveSearchUrl
      : `${this.predictiveSearchUrl}.json`;

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    try {
      console.log("[SearchForm] fetching suggestions for:", query);
      const predictiveSearchResponse = await fetch(
        `${predictiveSearchJsonUrl}?q=${encodeURIComponent(
          query
        )}&resources[limit]=6&resources[type]=product,collection,page,article&resources[options][unavailable_products]=last&resources[options][prefix]=last`,
        {
          signal: this.abortController.signal,
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!predictiveSearchResponse.ok) {
        throw new Error("Predictive search request failed");
      }

      const predictiveSearchData = await predictiveSearchResponse.json();
      console.log("[SearchForm] predictive response:", predictiveSearchData);

      if (query !== this.input.value.trim()) {
        return;
      }

      const resources = predictiveSearchData.resources?.results || {};
      const entries = [];
      const resultTypeLabels = {
        products: "Product",
        collections: "Collection",
        pages: "Page",
        articles: "Article",
      };
      ["products", "collections", "pages", "articles"].forEach((type) => {
        (resources[type] || []).forEach((item) => {
          entries.push({
            type: resultTypeLabels[type] || "Result",
            title: item.title,
            url: item.url,
          });
        });
      });

      console.log("[SearchForm] suggestions received:", entries.length);
      this.renderSuggestions(entries.slice(0, 6));
    } catch (error) {
      if (error.name !== "AbortError") {
        console.log("[SearchForm] suggestions fetch failed:", error);
        this.clearSuggestions();
      }
    }
  }

  renderSuggestions(entries) {
    if (!entries.length) {
      this.clearSuggestions();
      return;
    }

    this.suggestions.innerHTML = `<ul class="form-search__suggestions-list" role="list">${entries
      .map(
        (entry) => `<li class="form-search__suggestion-item">
            <a class="form-search__suggestion-link" href="${entry.url}">
              <span class="form-search__suggestion-title">${this.escapeHtml(entry.title)}</span>
              <span class="form-search__suggestion-type">${entry.type}</span>
            </a>
          </li>`
      )
      .join("")}</ul>`;
    this.suggestions.classList.remove("visually-hidden");
  }

  clearSuggestions() {
    if (!this.suggestions) {
      return;
    }

    this.suggestions.innerHTML = "";
    this.suggestions.classList.add("visually-hidden");
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }
}

function initSearchForms() {
  const searchInputs = document.querySelectorAll(".js-search-input");
  console.log("[SearchForm] inputs found:", searchInputs.length);

  searchInputs.forEach((search) => {
    if (search.dataset.searchFormInitialized === "true") {
      return;
    }

    search.dataset.searchFormInitialized = "true";

    try {
      new SearchForm(search);
    } catch (error) {
      console.log("[SearchForm] initialization failed:", error);
    }
  });
}

const productGrid = document.getElementById("product-grid");
const articleGrid = document.getElementById("blog-grid");

function infScroll(container, append) {
  let parent = container.parentNode,
    pagination = parent.querySelector(".pagination"),
    viewMore = document.querySelector(".view-more");

  if (pagination !== null) {
    console.log("pagination exists");

    let infScrollActive = pagination.getAttribute("data-inf-scroll");

    if (infScrollActive === "true") {
      console.log("infinite scroll active");

      let viewMoreText = viewMore.querySelector(".view-more__button");
      viewMore.classList.remove("visually-hidden"); // show view more button
      console.log("display view more button");

      infiniteScroll = new InfiniteScroll(container, {
        // options
        hideNav: ".pagination",
        scrollThreshold: false,
        path: ".pagination__step.next",
        append: append,
        // history: true,
        // historyTitle: true,
        button: ".view-more__button",
        scrollThreshold: false,
        onInit: function () {
          this.on("load", function () {
            console.log("Infinite Scroll load");
          });
          this.on("request", function () {
            console.log("Infinite Scroll request");
            viewMoreText.textContent = "Loading…";
          });
          this.on("append", function (body, path, items, response) {
            console.log("Infinite Scroll append path - " + path);
            console.log("Infinite Scroll append length - " + items.length);
            console.log("Infinite Scroll append response - " + response.status);
            intObs();
            viewMoreText.textContent = "View More";
          });
          this.on("error", function () {
            console.log("Infinite Scroll error");
          });
        },
      });
    } else {
      console.log("infinite scroll disabled in settings");
      return;
    }
  } else {
    console.log("no pagination");
  }
}

let isHeaderTransparent = false;

indexTransparentHeader = () => {
  let header = document.querySelector("header"),
    firstSection = document.querySelector("main#MainContent section:first-of-type"),
    hero = document.querySelector("section.hero"),
    transparentCheck = header.classList.contains("transparent"),
    megamenu = document.querySelector(".megamenu"),
    search = document.querySelector(".header-search"),
    miniCartCheck = document.querySelector(".mini-cart.open") !== null;

    // console.log("firstSection", firstSection);
  

  if (transparentCheck) {
    // console.log("header is transparent");
    let lastKnownState = null;

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          let isTransparent = entry.intersectionRatio > 0.25;
          if (lastKnownState !== isTransparent) {
            lastKnownState = isTransparent;
            if (isTransparent) {
              header.classList.add("transparent--visible");
              // console.log("header is transparent");
            } else {
              header.classList.remove("transparent--visible");
              // console.log("header is not transparent");
            }
          }
        });
      },
      {
        threshold: 0.25,
      }
    );

    observer.observe(firstSection);

    header.addEventListener("mouseover", function () {
      header.classList.remove("transparent--visible");
      isHeaderTransparent = false;
    });

    header.addEventListener("mouseleave", function () {
      if (lastKnownState && !isMiniCartOpen) {
          header.classList.add("transparent--visible");
          isHeaderTransparent = true;
          wasTransparent = true;
      }
    });

    if (megamenu) {
      megamenu.addEventListener("mouseover", function () {
        header.classList.remove("transparent--visible");
        megamenu.setAttribute("aria-expanded", true);
        isHeaderTransparent = false;
      });

      megamenu.addEventListener("mouseleave", function () {
        if (lastKnownState) {
          header.classList.add("transparent--visible");
          isHeaderTransparent = true;
        }
      });
      
    }

    // if (search) {
    //   search.addEventListener("mouseover", function () {
    //     header.classList.remove("transparent--visible");
    //   });

    //   search.addEventListener("mouseleave", function () {
    //     if (lastKnownState) {
    //       header.classList.add("transparent--visible");
    //     }
    //   });
    // }
  }
};



indexTransparentHeader();

function infScrollReset() {
  console.log("reset inf scroll");
  let append = "li.product-card";

  if (typeof infiniteScroll !== "undefined" && infiniteScroll !== null) {
    infiniteScroll.destroy();
  } else {
    console.log("infiniteScroll is not defined");
    return;
  }

  if (productGrid) {
    console.log("product grid");
    let latestProductGrid = document.querySelector(
      "#ProductGridContainer #product-grid"
    );
    append = "li.product-card";
    infScroll(latestProductGrid, append);
  } else if (articleGrid) {
    console.log("article grid");
    let latestArticleGrid = document.querySelector("#article-grid");
    append = "li.article-card";
    infScroll(latestArticleGrid, append);
    intObs();
  } else {
    console.log("no grids");
  }
}

// Announcement Bar


function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Hero Carousel

function heroCarousel(slider) {

  let heroAutoplay = slider.getAttribute("data-autoplay"),
      heroAutoplaySpeed = slider.getAttribute("data-autoplay-speed");

  if (!heroAutoplay) {
    heroAutoplay = false;
  } else if (heroAutoplay === "true" && heroAutoplaySpeed !== null) {
    heroAutoplay = parseInt(heroAutoplaySpeed);
  } else {
    heroAutoplay = false;
  }


  var heroFlkty = new Flickity(slider, {
    wrapAround: true,
    prevNextButtons: false,
    cellSelector: ".hero__media--slide",
    autoPlay: heroAutoplay,
    pageDots: false,
    setGallerySize: false,
    draggable: true,
    fade: true,
  });


  slider.addEventListener("click", function (event) {

    heroFlkty.on("change", function (index) {
      var video = heroFlkty.selectedElement.querySelector("video");
      
      if (mq.matches) {
        video = slider.querySelector(".hero__media--video.show-desktop");
      } else {
        video = slider.querySelector(".hero__media--video.show-mobile");
      }
  
      if (video) {
          video.play();
          if (!video.paused) {
            console.log("change video is playing");
          } else {
            console.log("change video is paused");
          }
        } else {
          slider.querySelectorAll("video").forEach((video) => {
            video.pause();
          });
        }
      });
    heroFlkty.next(true, false)
  });

  // heroFlkty.on("change", function (index) {
  //   var video = heroFlkty.selectedElement.querySelector("video");

  //   if (video) {
  //     // console.log("play video");
  //     video.play();
  //     if (!video.paused) {
  //       console.log("change video is playing");
  //     } else {
  //       console.log("change video is paused");
  //     }
  //   } else {
  //     slider.querySelectorAll("video").forEach((video) => {
  //       video.pause();
  //     });
  //   }
  // });
}
const heroCarouselEl = ".hero--carousel";
const heroCarouselCheck = document.querySelector(heroCarouselEl) !== null;

if (heroCarouselCheck) {
  document.querySelectorAll(heroCarouselEl).forEach((slider) => {
    heroCarousel(slider);
  });
}

function ingredientsCarousel() {
  let carousel = document.querySelector(".ingredients__carousel"),
    details = document.querySelector(".ingredients__list__details"),
    multiCheck = carousel.classList.contains("ingredients-multi__carousel");

 

  if (carousel) {
    if (multiCheck) {
      console.log("ingredients carousel exists");
      // carousel.querySelector(".ingredients-card").classList.add("is-active");
      console.log("ingredients details exists");
      // details.querySelector(".ingredients-details__item").classList.add("is-active");
      }
    
    var ingredientsFlkty = new Flickity(carousel, {
      wrapAround: true,
      cellAlign: "center",
      prevNextButtons: false,
      cellSelector: ".ingredients-card",
      pageDots: false,
      draggable: true,
    });

    ingredientsFlkty.on("change", function (index) {
      let currentSlide = ingredientsFlkty.selectedElement,
        currentHandle = currentSlide.dataset.ingredient,
        currentDetails = details.querySelector(
          `[data-ingredient="${currentHandle}"]`
        );

      details.querySelectorAll(".ingredients-details__item").forEach((item) => {
        item.classList.remove("is-active");
      });

      currentDetails.classList.add("is-active");
    });
  }
}

const ingredientsCarouselCheck =
  document.querySelector(".ingredients__carousel") !== null;

function ingredientsSelect() {
  let list = document.querySelector(".ingredients__carousel"),
    details = document.querySelector(".ingredients__list__details"),
    listItems = list.querySelectorAll(".ingredients-card__image"),
    detailsItems = details.querySelectorAll(".ingredients-details__item"),
    multiCheck = list.classList.contains("ingredients-multi__carousel");

    if (multiCheck) {
      if (listItems.length > 0) {
        listItems[0].closest(".ingredients-card").classList.add("is-active");
      }
      if (detailsItems.length > 0) {
        detailsItems[0].classList.add("is-active");
      }
    }

  listItems.forEach((item) => {
    item.addEventListener("click", function (event) {
      let card = item.closest(".ingredients-card"),
        handle = card.dataset.ingredient;

      listItems.forEach((item) => {
        item.closest(".ingredients-card").classList.remove("is-active");
      });

      detailsItems.forEach((item) => {
        item.classList.remove("is-active");
      });

      card.classList.add("is-active");

      detailsItems.forEach((item) => {
        if (item.dataset.ingredient === handle) {
          item.classList.add("is-active");
        }
      });
    });
  });
}


function stickyNavObserver() {
  // On scroll, as section is visible check it's ID > add a class of 'is-active' to the nav a href with corresponding section ID

  let nav = document.querySelector(".sticky-nav__list");
  if (!nav) return; // Failsafe: only run if nav exists

  let navLinks = nav.querySelectorAll("a.sticky-nav__list__item__link"),
    navLinksHrefArray = Array.from(navLinks).map((link) =>
      link.getAttribute("href")
    );
  (sections = document.querySelectorAll(navLinksHrefArray.join(","))),
    (root = document.documentElement);

  let observerOptions = {
    root: null,
    rootMargin: "12% 0 12% 0",
    threshold: [0.25],
  };

  let observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        let sectionID = entry.target.id;

        console.log(sectionID);

        navLinks.forEach((link) => {
          link.parentNode.classList.remove("is-active");

          if (link.getAttribute("href") === `#${sectionID}`) {
            link.parentNode.classList.add("is-active");
          }

          if (window.matchMedia("(max-width: 1024px)").matches) {
            window.addEventListener("scroll", function () {
              let scrollRatio =
                window.scrollY /
                (document.documentElement.scrollHeight - window.innerHeight);
              let nav = document.querySelector(".sticky-nav__list");
              let maxHorizontalScroll = nav.scrollWidth - nav.clientWidth;
              let horizontalScrollPosition = scrollRatio * maxHorizontalScroll;

              nav.scrollTo({
                left: horizontalScrollPosition,
                behavior: "smooth",
              });
            });
          }
        });
      }
    }, observerOptions);
  });

  sections.forEach((section) => {
    observer.observe(section);
    console.log("observe section");
  });

  window.addEventListener("resize", function () {
    sections.forEach((section) => {
      observer.observe(section);
    });
  });
}

if (productCheck) {
  stickyNavObserver();
}


  
function onSubmitHidePopover(popover) {
  console.log('adding submit listener to popover form')
  
  // Use Upcart's official API event to detect when items are added to cart
  if (typeof window.upcartSubscribeAddedToCart === "function") {
    console.log('Setting up Upcart API event listener');
    
    const unsubscribe = window.upcartSubscribeAddedToCart(() => {
      console.log('Upcart add to cart detected, hiding popover');
      popover.hidePopover();
      // Unsubscribe to prevent memory leaks
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    });
  } else {
    console.log('Upcart API not available, checking for existing popup state');
    
    // Fallback: Check for existing Upcart popup state
    const bodyHasUpcartPopup = document.querySelector('body').classList.contains("upcartPopupShow");
    const htmlHasUpcartPopup = document.querySelector('html').classList.contains("upcartPopupShow");
    
    if (bodyHasUpcartPopup || htmlHasUpcartPopup) {
      console.log('Existing Upcart popup detected, hiding popover')
      popover.hidePopover();
      return;
    }
  }
  
  // Add regular submit button click handler
  console.log('adding click listener to popover form')
  var popoverButton = popover.querySelector("button[type='submit']");
  if (popoverButton) {
    popoverButton.addEventListener('click', () => {
      console.log('form clicked, hiding popover')
      popover.hidePopover();
    })  
  } else {
    console.log('No submit button found in popover')
  } 
}


//  Collection / Search scripts

collectionScripts = () => {
  // Filter
  let filterLinks = document.querySelectorAll(".js-filter-toggle");

  filterLinks.forEach((link) => {
    onFilterClick(link);
  });

  // Infinite Scroll

  // Infinite Scroll - Checks for pagination and appends to the grid
  // if (productGrid) {
  //   let latestProductGrid = document.querySelector("#product-grid"),
  //     append = "li.product-card";

  //   infScroll(latestProductGrid, append);
  // }
};

// Product scripts

productScripts = () => {
  // Product Recommendations
  reccs();

  // Read More Button
  // if (extendedDescription) {
  //   let buttons = document.querySelectorAll(".js-read-more");
  //   buttons.forEach((button) => {
  //     readMoreButton(button);
  //   });
  // }

  // Fixed Add to Cart — show sticky ATC when the in-page button leaves the viewport
  if (document.querySelector(".js-fix-on-scroll")) {
    fixedAddToCart();
  }

  let howToVideos = document.querySelectorAll(".how-to__media__video"),
      pdpVideos = document.querySelectorAll(".product-main__gallery video.gallery-media");

  howToVideos.forEach((video) => {

    videoIcon(video);
  });
  if (!mq.matches) {
    pdpVideos.forEach((video) => {
        videoIcon(video);
    });
  }
  // );
  // if (ingredientsCarouselCheck && !mq.matches) {
  //   ingredientsCarousel();
  // } else if (ingredientsCarouselCheck && mq.matches) {
  //   ingredientsSelect();
  // }
  
  
};

repeatScripts = () => {
  console.log("repeat scripts");

  // Scripts that need to be re-run on window resize, infinite scroll etc.
};

universalScripts = () => {
  // Toggle Expanded
  toggleExpandedEls();

  quickAddCloseListener();
  // Intersection Observer
  intObs();


  // Mini Cart
  // Check if upcart is in use

  if (upcartCheck) {
    console.log("upcart is active");
    onUpcart();
  } else {
    console.log("upcart is not active");
    const miniCartLinks = document.querySelectorAll(".js-cart");
    miniCartLinks.forEach((link) => {
      new MiniCart(link);
    });
  }


  // Mobile Menu
  const mobileMenuLinks = document.querySelectorAll(".js-menu");
  mobileMenuLinks.forEach((link) => {
    new MobileMenu(link); 
  });

  // Read More Button
  if (extendedDescription) {
    let buttons = document.querySelectorAll(".js-read-more");
    buttons.forEach((button) => {
      readMoreButton(button);
    });
  }

  // Search Form
  let searchInput = document.querySelectorAll(".js-search-input");
  searchInput.forEach((search) => {
    new SearchForm(search);
  });

  // Search Modal
  let searchLinks = document.querySelectorAll(".js-search");
  searchLinks.forEach((link) => {
    onSearchClick(link);
  });
};

blogScripts = () => {
  // Infinite Scroll

  if (articleGrid) {
    console.log("article grid");
    let latestArticleGrid = document.querySelector("#blog-grid");
    append = "li.article-card"; 
    infScroll(latestArticleGrid, append);
  }
};

// All Scripts
runScripts = () => {
  console.log("run scripts");
  universalScripts();
  if (productCheck) {
    productScripts();
  } else if (collectionCheck || searchCheck) {
    collectionScripts();
  } else if (blogCheck) {
    blogScripts();
  }
};

runScripts();


// Run scripts on window resize
window.addEventListener("resize", runScripts);
